export const WS_HOST = `wss://${window.location.host}/api/ws/main/`